'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _module = require('./mixins/module');

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FiltersAccordion = function (_Module) {
  (0, _inherits3.default)(FiltersAccordion, _Module);

  function FiltersAccordion(el) {
    (0, _classCallCheck3.default)(this, FiltersAccordion);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FiltersAccordion.__proto__ || (0, _getPrototypeOf2.default)(FiltersAccordion)).call(this, el));

    _this.els = {
      filterAccordions: _this.getContextElements('.' + _this.className)
    };

    _this.initialiseFiltersAccordion();
    return _this;
  }

  (0, _createClass3.default)(FiltersAccordion, [{
    key: 'initialiseFiltersAccordion',
    value: function initialiseFiltersAccordion() {
      var _this2 = this;

      document.addEventListener('click', function (e) {
        // Check if the clicked element matches the desired selector
        if (e.target.matches('.' + _this2.className + '_Header')) {
          var accordion = e.target.closest('.' + _this2.className);
          if (accordion) {
            accordion.classList.toggle('clc-Filters_Block-active');
          }
        }
      });
    }
  }]);
  return FiltersAccordion;
}(_module2.default);

exports.default = FiltersAccordion;